import { render, staticRenderFns } from "./manufacter-model.vue?vue&type=template&id=75332b1c"
import script from "./manufacter-model.vue?vue&type=script&lang=ts"
export * from "./manufacter-model.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports